import { Dispatch, useState } from 'react'
import { CurrentFlow, Frequency } from '../types'
import FrequencyPicker from './FrequencyPicker'
import RecurringDatePickerModal from 'components/RecurringDatePickerModal'
import DatePicker from 'components/DatePicker'
import {
  activationDateValue,
  firstDayValue,
  secondDayValue
} from '../LocalState'
import { SET_FREQUENCY } from 'constants/actions'
import styles from './ContributionScheduler.module.scss'

export const ContributionScheduler = ({
  flow,
  frequency,
  dispatch,
  activationDate,
  setActivationDate
}: Props) => {
  const [firstDay, setFirstDay] = useState(firstDayValue())
  const [secondDay, setSecondDay] = useState(secondDayValue())
  const [showFrequencyPickerModal, setShowFrequencyPickerModal] =
    useState(false)

  return (
    <div className={styles.rowContainer}>
      <div className={styles.row}>
        <p className={styles.smallLabel}>Frequency</p>
        <FrequencyPicker
          flow={flow}
          frequency={frequency}
          dispatch={dispatch}
        />
      </div>
      <div className={styles.row}>
        <p className={styles.smallLabel}>Schedule</p>
        {frequency === 'onetime' || frequency === 'annually' ? (
          <DatePicker
            title="Select date"
            activationDate={activationDate}
            onChange={(date: Date) => {
              setActivationDate(date)
              activationDateValue(date)
            }}
          />
        ) : (
          <RecurringDatePickerModal
            flow={flow}
            firstDay={firstDay}
            setFirstDay={(day) => {
              setFirstDay(day)
              firstDayValue(day)
            }}
            setSecondDay={(day) => {
              setSecondDay(day)
              secondDayValue(day)
            }}
            secondDay={secondDay}
            frequency={frequency}
            setFrequency={(frequency) => {
              dispatch({
                type: SET_FREQUENCY,
                payload: { frequency }
              })
            }}
            showFrequencyPickerModal={showFrequencyPickerModal}
            setShowFrequencyPickerModal={setShowFrequencyPickerModal}
          />
        )}
      </div>
    </div>
  )
}

interface Props {
  flow: CurrentFlow
  frequency: Frequency
  dispatch: Dispatch<{
    type: 'SET_FREQUENCY'
    payload: { frequency: Frequency }
  }>
  activationDate: Date
  setActivationDate: (date: Date) => void
}
